import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

import Home from "./pages/Home";
import Marketplace from "./pages/Marketplace";
import DogDetail from "./pages/DogDetail";
import Boerboels from "./pages/Boerboels";
import Breeders from "./pages/Breeders";
import BreederDetail from "./pages/BreederDetail";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Programs from "./pages/Programs";
import Partners from "./pages/Partners";
import ProgramDetail from "./pages/ProgramDetail";
import Academy from "./pages/Academy";
import CourseDetail from "./pages/CourseDetail";
import BreedLibrary from "./pages/BreedLibrary";
import BreedDetail from "./pages/BreedDetail";
import Services from "./pages/Services";
import Community from "./pages/Community";
import Membership from "./pages/Membership";
import TrustSafety from "./pages/TrustSafety";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Cart from "./pages/Cart";
import Favorites from "./pages/Favorites";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/dogs" element={<Marketplace />} />
      <Route path="/dogs/:id" element={<DogDetail />} />
      <Route path="/boerboels" element={<Boerboels />} />
      <Route path="/boerboels/academy" element={<Academy canineOnly />} />
      <Route path="/boerboels/programs" element={<Programs ownerOnly />} />
      <Route path="/breeders" element={<Breeders />} />
      <Route path="/breeders/:id" element={<BreederDetail />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/:id" element={<ProductDetail />} />
      <Route path="/programs" element={<Programs />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/programs/:slug" element={<ProgramDetail />} />
      <Route path="/academy" element={<Academy />} />
      <Route path="/academy/:id" element={<CourseDetail />} />
      <Route path="/breeds" element={<BreedLibrary />} />
      <Route path="/breeds/:slug" element={<BreedDetail />} />
      <Route path="/services" element={<Services />} />
      <Route path="/community" element={<Community />} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/trust-safety" element={<TrustSafety />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/favorites" element={<Favorites />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRoutes />
            <Toaster position="top-right" theme="dark" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}
